<template>
    <div>
        <b-row>
            <b-col cols="4" cols-lg="3">{{ $t("contacts.lists.wizard.list-details-label-name") }}</b-col>
            <b-col cols-lg="7">{{ contactList.name }}</b-col>
        </b-row>

        <b-row>
            <b-col cols="4" cols-lg="3">{{ $t("contacts.lists.wizard.list-details-label-description") }}</b-col>
            <b-col cols-lg="7">{{ contactList.description }}</b-col>
        </b-row>

        <b-row>
            <b-col cols="4" cols-lg="3">{{ $t("contacts.lists.wizard.list-details-contacts-total") }}</b-col>
            <b-col cols-lg="7">{{ contactList.contacts ? contactList.contacts.length : "" }}</b-col>
        </b-row>

        <b-table
            :fields="columns"
            :items="contactList.contacts"
            :no-border-collapse="false"
            :no-sort-reset="true"
            :sticky-header="true"
            class="mt-4"
            responsive
        >
            <template #cell(labels)="data">
                <b-badge
                    v-for="label in data.item.labels"
                    :key="label.id"
                    :style="styleByColor(label.color)"
                    class="mr-50 badge-margin"
                >
                    {{ label.name }}
                </b-badge>
            </template>
        </b-table>
    </div>
</template>

<script>
import { BTable, BRow, BCol, BBadge } from "bootstrap-vue";
import { styleByColor } from "@/utils/color";
import useContactsLists from "@/composables/useContactsLists";

export default {
    components: {
        BTable,
        BRow,
        BCol,
        BBadge,
    },
    props: {
        contactList: {},
    },
    setup() {
        const { columns } = useContactsLists();

        return {
            styleByColor,
            columns,
        };
    },
};
</script>
